import React from 'react';
import PropTypes from 'prop-types';
import './styles.styl';

const sumScores = scores => {
  return Object.keys(scores).reduce((sum, path) => {
    return sum + scores[path];
  }, 0);
};

const Scoreboard = ({ scores, possibleScores }) => {
  const totalScore = sumScores(scores);
  const totalPossibleScore = sumScores(possibleScores);

  return (
    <div className="scoreboard">
      <div className="scoreboard__user-score">Your score: {totalScore}</div>

      <div className="scoreboard__possible-score">
        Possible score: {totalPossibleScore}
      </div>
    </div>
  );
};

Scoreboard.propTypes = {
  scores: PropTypes.object
};

export default Scoreboard;



// WEBPACK FOOTER //
// ../core/src/components/Scoreboard/Scoreboard.js